let date = new Date();
let d = date.getDate();
let m = date.getMonth();
let y = date.getFullYear();

export const adminInfo = {
    navbarMenu: [
        {name: 'Overview', subheading: 'Subheading', link: '#tab_1', link_class: 'active', class_name: 'active', toggle: 'tab'},
        {name: 'MCAT', subheading: 'Subheading', link: '#tab_2', link_class: '', class_name: '', toggle: 'tab'},
        {name: 'GMAT', subheading: 'Subheading', link: '#tab_3', link_class: '', class_name: '', toggle: 'tab'},
        {name: 'LSAT', subheading: 'Subheading', link: '#tab_4', link_class: '', class_name: '', toggle: 'tab'},
        {name: 'GRE', subheading: 'Subheading', link: '#tab_5', link_class: '', class_name: '', toggle: 'tab'},
        {name: 'In-Person Courses', subheading: 'Subheading', role: 'button', link_class: 'dropdown-toggle', class_name: 'dropdown pull-right', toggle: 'tab', caret: 'caret',
            childList: [
                {role: 'presentation', roleLink: 'menuitem', link: 'in-person-session', title: 'MCAT - 06/05/2017'},
                {role: 'presentation', roleLink: 'menuitem', link: 'in-person-session', title: 'LSAT - 06/05/2017'},
                {role: 'presentation', roleLink: 'menuitem', link: 'in-person-session', title: 'GMAT - 06/05/2017'},
                {role: 'presentation', roleLink: 'menuitem', link: 'in-person-session', title: 'GRE - 06/05/2017'}
            ]
        }
    ],
    adminEvents: {
        events: [
            {
                title: 'Day off',
                start: new Date(y, m, 1),
                end: new Date(y, m, 1),
                backgroundColor: "#f56954",
                borderColor: "#f56954"
            },
            {
                title: 'Long Event',
                start: new Date(y, m, d - 5),
                end: new Date(y, m, d - 2),
                backgroundColor: "#f39c12",
                borderColor: "#f39c12"
            },
            {
                title: 'Meeting',
                start: new Date(y, m, d, 10, 30),
                allDay: true,
                backgroundColor: "#0073b7",
                borderColor: "#0073b7"
            },
            {
                title: 'Lunch',
                start: new Date(y, m, d, 12, 0),
                end: new Date(y, m, d, 14, 0),
                allDay: false,
                backgroundColor: "#00c0ef",
                borderColor: "#00c0ef"
            },
            {
                title: 'Birthday Party',
                start: new Date(y, m, d + 1, 19, 0),
                end: new Date(y, m, d + 1, 22, 30),
                allDay: false,
                backgroundColor: "#00a65a",
                borderColor: "#00a65a"
            },
            {
                title: 'Click for Google',
                start: new Date(y, m, 28),
                end: new Date(y, m, 29),
                url: 'http://google.com/',
                backgroundColor: "#3c8dbc",
                borderColor: "#3c8dbc"
            }
        ],
        dragEvents: [
            {backgroundColor: 'green', title: 'Test Day'},
            {backgroundColor: 'yellow', title: 'Question Answer Hour'},
            {backgroundColor: 'aqua', title: 'Test Checking'},
            {backgroundColor: 'light-blue', title: 'Lecture'},
            {backgroundColor: 'red', title: 'Day Off'}
        ],
        studentsStatistic: [
            {title: 'Total Students', count: '750', link: '#' },
            {title: 'Students Online', count: '39', link: '#OnlineStudentsModal'},
            {title: 'Students writing in the next month', count: '212', link: '#'},
            {title: 'Responses since last log-in', count: '35', link: '#ResponsesModal'}
        ],
        colorsEvents: [
            'aqua', 'blue', 'light-blue', 'teal', 'yellow', 'orange', 'green', 'lime', 'red', 'purple', 'fuchsia', 'muted', 'navy'
        ]
    },
    usersStatus: {
        columnsTable: [
            {title: 'Name', prop: 'name', defaultChecked: true, value: 0},
            {title: 'Status', prop: 'status', defaultChecked: true, value: 1},
            {title: 'Start date', prop: 'start_date', defaultChecked: true, value: 2},
            {title: 'Last Active', prop: 'last_active', defaultChecked: true, value: 3},
            {title: 'Avg S. Time', prop: 'avg_time', defaultChecked: true, value: 4},
            {title: 'Test Date', prop: 'test_date', defaultChecked: true, value: 5},
            {title: 'Office Score', prop: 'office_score', value: 6},
            {title: 'IM Res', prop: 'im_res', value: 7},
            {title: 'Activity Status', prop: 'activity', value: 8},
            {title: 'Course GP', prop: 'course_gp', value: 9},
            {title: 'Course Completion', prop: 'course_completion', value: 10},
            {title: 'Course LSS', prop: 'course_lss', value: 11},
            {title: 'In-Person', prop: 'in_person', value: 12},
            {title: 'Expected Score', prop: 'expected_score', value: 13},
            {title: 'Practice T.Score', prop: 'practice_t_score', value: 14},
            {title: 'Scording About 90%', prop: 'scording_about', value: 15},
            {title: 'On Target With Me', prop: 'on_target_with_me', value: 16},
        ],
        dataTable: [
            {
                name: 'Abdul-Muqtadir Kattan',
                status: 'Active',
                start_date: '18/12/2017',
                last_active: '10 months ago',
                avg_time: '34 min',
                test_date: '11/11/2017',
                office_score: '546',
                im_res: '5',
                activity: 'On Par',
                course_gp: 'asdf',
                course_completion: '17/04/2018',
                course_lss: 'CARS',
                in_person: 'Yes',
                expected_score: '519',
                practice_t_score: '510',
                scording_about: 'No',
                on_target_with_me: 'Yes',
                options: 'options'
            },
            {
                name: 'Abigail Morris',
                status: 'Active',
                start_date: '03/04/2017',
                last_active: '9 months ago',
                avg_time: '20 min',
                test_date: '10/04/2017',
                office_score: '542',
                im_res: '8',
                activity: 'Ahead',
                course_gp: 'asdf',
                course_completion: '18/11/2018',
                course_lss: 'Math',
                in_person: 'No',
                expected_score: '535',
                practice_t_score: '544',
                scording_about: 'Yes',
                on_target_with_me: 'No',
                options: 'options'
            },
            {
                name: 'Adnan Saliba',
                status: 'Not Preparing',
                start_date: '07/03/2017',
                last_active: '2 months ago',
                avg_time: '39 min',
                test_date: '05/03/2017',
                office_score: '504',
                im_res: '5',
                activity: 'On Par',
                course_gp: 'asdf',
                course_completion: '10/12/2018',
                course_lss: 'Math',
                in_person: 'No',
                expected_score: '523',
                practice_t_score: '524',
                scording_about: 'No',
                on_target_with_me: 'No',
                options: 'options'
            },
            {
                name: 'Christian Rowcroft',
                status: 'Complete',
                start_date: '01/12/2017',
                last_active: '1 months ago',
                avg_time: '46 min',
                test_date: '01/12/2017',
                office_score: '524',
                im_res: '9',
                activity: 'Ahead',
                course_gp: 'asdf',
                course_completion: '18/12/2018',
                course_lss: 'Biology',
                in_person: 'Yes',
                expected_score: '538',
                practice_t_score: '543',
                scording_about: 'Yes',
                on_target_with_me: 'No',
                options: 'options'
            },
            {
                name: 'Dhakwan Naser',
                status: 'Active',
                start_date: '20/02/2017',
                last_active: '5 months ago',
                avg_time: '25 min',
                test_date: '18/10/2017',
                office_score: '525',
                im_res: '8',
                activity: 'On Par',
                course_gp: 'asdf',
                course_completion: '07/06/2018',
                course_lss: 'Physics',
                in_person: 'No',
                expected_score: '550',
                practice_t_score: '548',
                scording_about: 'Yes',
                on_target_with_me: 'No',
                options: 'options'
            },
            {
                name: 'Elizabeth Rhoads',
                status: 'Complete',
                start_date: '22/07/2017',
                last_active: '10 months ago',
                avg_time: '47 min',
                test_date: '11/12/2017',
                office_score: '502',
                im_res: '8',
                activity: 'Ahead',
                course_gp: 'asdf',
                course_completion: '10/08/2018',
                course_lss: 'Biology',
                in_person: 'No',
                expected_score: '512',
                practice_t_score: '505',
                scording_about: 'No',
                on_target_with_me: 'Yes',
                options: 'options'
            },
            {
                name: 'Jad Allah Sarraf',
                status: 'Complete',
                start_date: '10/07/2017',
                last_active: '11 months ago',
                avg_time: '27 min',
                test_date: '28/10/2017',
                office_score: '509',
                im_res: '8',
                activity: 'On Par',
                course_gp: 'asdf',
                course_completion: '03/12/2018',
                course_lss: 'Biology',
                in_person: 'No',
                expected_score: '535',
                practice_t_score: '504',
                scording_about: 'Yes',
                on_target_with_me: 'Yes',
                options: 'options'
            },
            {
                name: 'Jesse Broome',
                status: 'Complete',
                start_date: '18/02/2017',
                last_active: '1 months ago',
                avg_time: '27 min',
                test_date: '10/08/2017',
                office_score: '532',
                im_res: '9',
                activity: 'Ahead',
                course_gp: 'asdf',
                course_completion: '05/03/2018',
                course_lss: 'Physics',
                in_person: 'No',
                expected_score: '527',
                practice_t_score: '530',
                scording_about: 'Yes',
                on_target_with_me: 'No',
                options: 'options'
            },
            {
                name: 'Joel Kerr',
                status: 'Not Preparing',
                start_date: '09/05/2017',
                last_active: '4 months ago',
                avg_time: '10 min',
                test_date: '16/09/2017',
                office_score: '538',
                im_res: '7',
                activity: 'On Par',
                course_gp: 'asdf',
                course_completion: '29/11/2018',
                course_lss: 'Physics',
                in_person: 'No',
                expected_score: '544',
                practice_t_score: '502',
                scording_about: 'No',
                on_target_with_me: 'Yes',
                options: 'options'
            },
            {
                name: 'Jonathan Taylor',
                status: 'Not Preparing',
                start_date: '07/03/2017',
                last_active: '6 months ago',
                avg_time: '26 min',
                test_date: '10/07/2017',
                office_score: '513',
                im_res: '6',
                activity: 'Ahead',
                course_gp: 'asdf',
                course_completion: '08/04/2018',
                course_lss: 'Physics',
                in_person: 'No',
                expected_score: '525',
                practice_t_score: '513',
                scording_about: 'Yes',
                on_target_with_me: 'Yes',
                options: 'options'
            },
            {
                name: 'Kiera Blackburn',
                status: 'Active',
                start_date: '13/01/2018',
                last_active: '10 months ago',
                avg_time: '38 min',
                test_date: '12/04/2017',
                office_score: '511',
                im_res: '5',
                activity: 'Ahead',
                course_gp: 'asdf',
                course_completion: '20/09/2018',
                course_lss: 'CARS',
                in_person: 'No',
                expected_score: '530',
                practice_t_score: '534',
                scording_about: 'No',
                on_target_with_me: 'No',
                options: 'options'
            },
            {
                name: 'Lily Laidlaw',
                status: 'Complete',
                start_date: '15/08/2017',
                last_active: '3 months ago',
                avg_time: '24 min',
                test_date: '22/02/2017',
                office_score: '515',
                im_res: '9',
                activity: 'Lagging',
                course_gp: 'asdf',
                course_completion: '27/03/2018',
                course_lss: 'Biology',
                in_person: 'Yes',
                expected_score: '540',
                practice_t_score: '507',
                scording_about: 'Yes',
                on_target_with_me: 'No',
                options: 'options'
            },
            {
                name: 'Lily Walton',
                status: 'Not Preparing',
                start_date: '03/08/2017',
                last_active: '4 months ago',
                avg_time: '46 min',
                test_date: '25/06/2017',
                office_score: '536',
                im_res: '9',
                activity: 'Lagging',
                course_gp: 'asdf',
                course_completion: '24/01/2019',
                course_lss: 'Physics',
                in_person: 'No',
                expected_score: '537',
                practice_t_score: '538',
                scording_about: 'No',
                on_target_with_me: 'No',
                options: 'options'
            },
            {
                name: 'Najah Wasem',
                status: 'Complete',
                start_date: '12/04/2017',
                last_active: '10 months ago',
                avg_time: '55 min',
                test_date: '21/09/2017',
                office_score: '534',
                im_res: '6',
                activity: 'Ahead',
                course_gp: 'asdf',
                course_completion: '05/08/2018',
                course_lss: 'Physics',
                in_person: 'No',
                expected_score: '526',
                practice_t_score: '533',
                scording_about: 'Yes',
                on_target_with_me: 'Yes',
                options: 'options'
            },
            {
                name: 'Nicolette Daviau',
                status: 'Not Preparing',
                start_date: '09/10/2017',
                last_active: '10 months ago',
                avg_time: '36 min',
                test_date: '07/01/2018',
                office_score: '509',
                im_res: '8',
                activity: 'On Par',
                course_gp: 'asdf',
                course_completion: '09/06/2018',
                course_lss: 'Biology',
                in_person: 'No',
                expected_score: '511',
                practice_t_score: '534',
                scording_about: 'Yes',
                on_target_with_me: 'Yes',
                options: 'options'
            },
            {
                name: 'Safiy al Din Masih',
                status: 'Complete',
                start_date: '26/07/2017',
                last_active: '9 months ago',
                avg_time: '58 min',
                test_date: '27/10/2017',
                office_score: '508',
                im_res: '6',
                activity: 'On Par',
                course_gp: 'asdf',
                course_completion: '24/04/2018',
                course_lss: 'Math',
                in_person: 'No',
                expected_score: '503',
                practice_t_score: '520',
                scording_about: 'No',
                on_target_with_me: 'No',
                options: 'options'
            },
            {
                name: 'Shahd Khouri',
                status: 'Complete',
                start_date: '05/01/2018',
                last_active: '4 months ago',
                avg_time: '54 min',
                test_date: '23/08/2017',
                office_score: '522',
                im_res: '8',
                activity: 'On Par',
                course_gp: 'asdf',
                course_completion: '08/07/2018',
                course_lss: 'Physics',
                in_person: 'No',
                expected_score: '546',
                practice_t_score: '525',
                scording_about: 'No',
                on_target_with_me: 'Yes',
                options: 'options'
            },
        ],
        statisticDiagram: [
            {
                name: 'boys',
                stack: 1,
                data: [2, 6, 5, 0]
            },
            {
                name: 'girls',
                stack: 2,
                data: [0, 6, 1, 3]
            }
        ]
    },
    usersOnline: {
        total: 39,
        countUsersInCourses: [
            {nameCourse: 'MCAT', countStudents: 14},
            {nameCourse: 'LAST', countStudents: 12},
            {nameCourse: 'GRE', countStudents: 3},
            {nameCourse: 'GMAT', countStudents: 6}
        ],
        activeUsers: [14, 13, 15, 15, 13, 12, 15, 11, 8, 15, 13, 11, 13, 12, 12, 11, 14, 11, 13, 12, 10, 12, 10, 15, 11, 13, 14, 11, 11, 15]
    },
    usersResponses: [
        {name: 'Joel Kerr', course: 'GRE', time: '29 mins'},
        {name: 'Jesse Broome', course: 'GRE', time: '14 mins'},
        {name: 'Abigail Morris', course: 'GMAT', time: '26 mins'},
        {name: 'Finlay Lewis', course: 'GRE', time: '38 mins'},
        {name: 'Benjamin Ailleboust', course: 'GSAT', time: '31 mins'},
        {name: 'Sabeeh Sleiman', course: 'GMAT', time: '55 mins'},
        {name: 'Cameron Brose', course: 'GRE', time: '12 mins'},
        {name: 'Brooke Cutts', course: 'GSAT', time: '48 mins'},
        {name: 'Connor Simmons', course: 'GSAT', time: '42 mins'},
        {name: 'Isabella Bourke', course: 'LSAT', time: '35 mins'},
        {name: 'Melba Bailey', course: 'GMAT', time: '46 mins'},
    ]
};


// WEBPACK FOOTER //
// ./src/data/adminInfo.js